import Vue from 'vue'
import App from './App'
import axios from 'axios' // 数据请求
import VueAwesomeSwiper from 'vue-awesome-swiper' // 轮播图
import util from '../../../static/js/util.js'

Vue.config.productionTip = false

Vue.prototype.$http =  axios;
// 设置全局图片基本url
// Vue.prototype.resourceUrl = 'http://resource.breadoffer.com';
Vue.prototype.resourceUrl = util.Domain.getImg();

// 通过url获取参数的函数
Vue.prototype.GetQueryString = function (name){
  var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if(r!=null)return  unescape(r[2]); return null;
}

Vue.use(VueAwesomeSwiper);

// 导入公共部分
import '../../../static/css/reset.css' // 重置样式
import '../../../static/css/plugin-common.css' // 重置样式
import 'iview/dist/styles/iview.css'; // iview组件css
import 'swiper/dist/css/swiper.css'; // swiper组件css

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/module/list/list.js